import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      maxWidth: 1300,
      width: "100%",
    },
    leftColumn: {
      alignItems: "center",
      flexDirection: "column",
      flex: 1,
      justifyContent: "center",
      width: "50%",
      [theme.breakpoints.up("lg")]: {
        width: "auto",
      },
      "& + $rightColumn": {
        marginLeft: theme.spacing(3),
      },
    },
    rightColumn: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      width: "50%",
      [theme.breakpoints.up("lg")]: {
        maxWidth: 500,
        width: "auto",
      },
    },
  })
);
